import 'slick-carousel';

const $sliderFeaturedSuites = $('.js-slick-slider-featured-suites');
const $statusSliderFeaturedSuites = $('.js-slick-slider-featured-suites-counter');

$sliderFeaturedSuites.on('init reInit afterChange', (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    $statusSliderFeaturedSuites.text(i + '/' + slick.slideCount);
});

$sliderFeaturedSuites.slick({
    centerPadding: '0',
    cssEase: 'ease-out',
    pauseOnFocus: false,
    pauseOnHover: false,
    mobileFirst: true,
    slidesToShow: 1,
    speed: 500,
    prevArrow: $('.js-prev-slide-in-slider-featured-suites'),
    nextArrow: $('.js-next-slide-in-slider-featured-suites'),
    responsive: [{
        breakpoint: 991,
        settings: {
            slidesToShow: 2
        }
    }
    ]
});

// Customized lazy loading for Slick Slider
// Purpose: Prevent lazy loading for siblings slides
// Now it's really 'ondemand' lazy loading
$sliderFeaturedSuites.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    const $imagePrevObj = $sliderFeaturedSuites.find(`div[data-slick-index="${nextSlide}"]`).find('img');
    const $imageNextObj = $sliderFeaturedSuites.find(`div[data-slick-index="${nextSlide + 1}"]`).find('img');
    const imagePrevSrc = $imagePrevObj.data('lazy-custom');
    const imageNextSrc = $imageNextObj.data('lazy-custom');

    if (imagePrevSrc !== $imagePrevObj.attr('src')) {
        $imagePrevObj.attr('data-lazy', imagePrevSrc);
    }
    if (imageNextSrc !== $imageNextObj.attr('src')) {
        $imageNextObj.attr('data-lazy', imageNextSrc);
    }
});
